import React from 'react'
import { Button, Flex, Text } from '@workwhile/ui'
import { Mic, MicOff, PhoneOff } from 'lucide-react'
import { useVoiceAgentCallContextValue } from '../context/VoiceAgentCallContext'

export const CallControls = () => {
  const {
    state: { isMuted },
    actions: { toggleMute, endCall },
  } = useVoiceAgentCallContextValue()

  return (
    <Flex gap={2} alignItems="center">
      <Button
        variant="secondary"
        kind="medium"
        onClick={toggleMute}
        title={isMuted ? 'Unmute' : 'Mute'}
      >
        <Flex alignItems="center" gap={1}>
          {isMuted ? <MicOff size={14} /> : <Mic size={14} />}
          <Text>{isMuted ? 'Unmute' : 'Mute'}</Text>
        </Flex>
      </Button>
      <Button
        kind="medium"
        onClick={endCall}
        style={{
          backgroundColor: '#e53e3e',
          color: 'white',
          borderColor: '#e53e3e',
        }}
      >
        <Flex alignItems="center" gap={1}>
          <PhoneOff size={14} />
          <Text color="white">End Call</Text>
        </Flex>
      </Button>
    </Flex>
  )
}
